module.exports = __webpack_public_path__ + "static/media/brown.f735b609.svg";